class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.header.preventHide = false;

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code === "Escape" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (event.target.closest("details").hasAttribute("open")) {
      this.close();
      this.header.preventHide = false;

      if (event.currentTarget.classList.contains('header__icon--search')) {
        document.querySelector('.header__overlay').classList.remove('active');
      }
    } else {
      this.open(event);
      if (!this.header) return;
      this.header.preventHide = this.detailsContainer.open;

      if (event.currentTarget.classList.contains('header__icon--search')) {
        document.querySelector('.header__overlay').classList.add('active');
      }
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay"))
      this.close(false);
  }

  getSectionHeader() {
    return this.header?.closest('.shopify-section-header') || null;
  }

  isTransparentHeaderPage() {
    const main = document.getElementById('MainContent');
    const sectionFirstChildTransparent = main?.querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]');
    const headerTransparent = this.header?.classList.contains('header-wrapper--full-width');
    return sectionFirstChildTransparent && headerTransparent;
  }

  showSolidHeaderBackground() {
    const sectionHeader = this.getSectionHeader();
    if (!sectionHeader || !this.classList.contains('header__search')) return;

    if (sectionHeader.classList.contains('color-background-overlay')) {
      sectionHeader.classList.remove('color-background-overlay');
      sectionHeader.classList.forEach((className) => {
        if (className.startsWith('color-background-') && className !== 'color-background-overlay' && className !== 'color-background-overlay-hidden') {
          sectionHeader.classList.remove(className);
        }
      });
      sectionHeader.classList.add('color-background-overlay-hidden');
    }

    sectionHeader.classList.add('header-search-open');
  }

  restoreTransparentHeaderBackground() {
    const sectionHeader = this.getSectionHeader();
    if (!sectionHeader || !this.classList.contains('header__search') || !sectionHeader.classList.contains('header-search-open')) return;

    sectionHeader.classList.remove('header-search-open');

    if (
      sectionHeader.matches(':hover') ||
      sectionHeader.classList.contains('shopify-section-header-sticky') ||
      sectionHeader.classList.contains('shopify-section-header-scroll') ||
      sectionHeader.querySelector('.menu-drawer-container')?.classList.contains('menu-opening')
    ) {
      return;
    }

    if (!this.isTransparentHeaderPage()) {
      sectionHeader.classList.remove('color-background-overlay-hidden');
      return;
    }

    const colorScheme = document.querySelector('main')?.querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
    sectionHeader.classList.remove('color-background-overlay-hidden');
    sectionHeader.classList.add('color-background-overlay');
    if (colorScheme) sectionHeader.classList.add(colorScheme);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    this.showSolidHeaderBackground();
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
    this.header.preventHide = false;

    this.restoreTransparentHeaderBackground();

    document.querySelector('.header__overlay')?.classList.remove('active');
  }
}

customElements.define("details-modal", DetailsModal);
